"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackerBox = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const hooks_1 = require("../hooks");
const animation_1 = require("../utils/animation");
const NotchedCorner_1 = require("./NotchedCorner");
const HackerBox = (_a) => {
    var { children, headerBar, innerContainerProps, themeColor, notchedCorner, notchedCornerSize = 16 } = _a, props = __rest(_a, ["children", "headerBar", "innerContainerProps", "themeColor", "notchedCorner", "notchedCornerSize"]);
    const { primaryColor: defaultColor } = (0, hooks_1.usePrimaryColor)();
    const color = (0, react_2.useMemo)(() => themeColor !== null && themeColor !== void 0 ? themeColor : defaultColor, [themeColor, defaultColor]);
    return (react_2.default.createElement(animation_1.MotionFlex, Object.assign({ bgColor: "black", direction: "column", position: "relative" }, props),
        headerBar && react_2.default.createElement(react_1.Box, { height: "18px", width: "full", backgroundColor: color }),
        react_2.default.createElement(react_1.Box, Object.assign({ borderWidth: "1px", borderColor: color, borderStyle: "1px", padding: 3, width: "full", maxHeight: "full", flex: 1 }, innerContainerProps),
            notchedCorner && (react_2.default.createElement(NotchedCorner_1.NotchedCorner, { position: notchedCorner, size: notchedCornerSize })),
            children)));
};
exports.HackerBox = HackerBox;
//# sourceMappingURL=HackerBox.js.map